module.exports = __webpack_public_path__ + "3b29f7b6b4491776239485f9de3c485f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/reading/question.png
// module id = 350
// module chunks = 0